/* eslint-disable import/no-cycle */
import CallbackManagement from '../views/merchant-callback-management/CallbackManagement.vue';
import DetailManagementMerchantApi from '../views/merchant-callback-management/DetailManagementMerchantApi.vue';
import Parent from '../views/Parent.vue';

import { setBreadcrumb } from './index';

const callbackManagementRoute = {
  path: '/management-merchant-api',
  meta: {
    title: 'BNI QRIS - Management Merchant API',
    appBarTitle: 'Management Merchant API',
  },
  component: Parent,
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Management Merchant API',
        appBarTitle: 'Management Merchant API',
        breadcrumbs: () => [
          setBreadcrumb('Management Merchant API', '/management-merchant-api', true),
        ],
      },
      component: CallbackManagement,
    },
    {
      path: '/management-merchant-api/detail/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Detail Management Merchant API',
        appBarTitle: 'Detail Management Merchant API',
        breadcrumbs: (params) => {
          const { id } = params;
    
          return [
            setBreadcrumb('Management Merchant API', '/management-merchant-api'),
            setBreadcrumb('Detail Management Merchant API', '/management-merchant-api/detail', true),
            setBreadcrumb(`${id}`, `/management-merchant-api/detail/${id}`),
          ];
        },
      },
      component: DetailManagementMerchantApi,
      name: 'Detail Management Merchant API',
    },
  ],
};
export default callbackManagementRoute;
